export const formatWords = { imagem: "imagem", video: "vídeo", carrossel: "carrossel" } as const;
